import React, {Component} from 'react';
import {PropTypes} from 'prop-types'
import _map from 'lodash/map';
import HrbTranslate from "../language/HrbTranslate";
import Lang from '../language/services/Lang';
import {connect} from 'react-redux';
import {getLanguage, isFrenchActive} from "../../store/rootReducer";
import OptionsUtil from "../../services/util/OptionsUtil";

/**
 * This CardWidgetSelectDropdown can accept options in two separate ways
 *
 * 1) Either pass in a key to the 'options.json' file in this.props.options
 *
 * OR
 *
 * 2) Pass in options from this.props.customOptions of the format
 * [{
 * value: '',
 * en: '',
 * fr: ''
 * }]
 */
class CardWidgetSelectDropdown extends Component {

  getOptionsFromJsonFile = () => {
    let options = OptionsUtil.getOptions(this.props.options);
    return _map(options, (option) => {
      return (
          <option key={option.value} value={option.value}>
            {Lang.getValue(option.text, this.props.language, option.textParams)}
          </option>
      )
    });
  };

  getOptionsFromCustomOptions = () => {
    return _map(this.props.customOptions, (option) => {
      let text = option.en;
      if (this.props.isFrenchActive) {
        text = option.fr;
      }
      return (
          <option key={option.value} value={option.value}>
            {text}
          </option>
      )
    });
  };

  getOptions = () => {
    if (this.props.options) {
      return this.getOptionsFromJsonFile();
    } else if (this.props.customOptions) {
      return this.getOptionsFromCustomOptions();
    }
  };

  render() {
    return (
        <div>
          <div className="hrb-card-widget-input-label">
            <HrbTranslate text={this.props.fieldLabel}/>
          </div>
          <select className="form-control hrb-card-widget-input" onChange={this.props.onChange}>
            <option value=''/>
            { this.getOptions() }
          </select>
        </div>
    )
  }
}

CardWidgetSelectDropdown.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.string,
  customOptions: PropTypes.array,
  fieldLabel: PropTypes.string
};

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state),
    isFrenchActive: isFrenchActive(state)
  }
};

export default connect(mapStateToProps)(CardWidgetSelectDropdown);